import {Injectable} from '@angular/core';
import {CommandHandler} from './command-handler';

@Injectable()
export class CommandHandlerRegistryService {
  private handlers: Map<string, CommandHandler> = new Map();

  register(name: string, handler: CommandHandler): CommandHandlerRegistryService {
    if (this.handlers.has(name)) {
      throw new Error(`CommandHandler for command "${name}" has already been configured.`);
    }

    this.handlers.set(name, handler);

    return this;
  }

  fetch(name: string): CommandHandler {
    return this.handlers.get(name);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/command/command-registry.service.ts